import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import SiteFooter from "./SiteFooter";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, childrenNode, reactifiedChildren, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("SiteFooter");
            childrenNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "listsInner"
            })));

            if (!childrenNode) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return rehydrateChildren(childrenNode);

          case 5:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 8:
            _context.t0 = null;

          case 9:
            reactifiedChildren = _context.t0;
            props = {
              isRehydrating: true,
              children: reactifiedChildren
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(SiteFooter, props));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();